import { render } from "./AdminImportUrl.vue?vue&type=template&id=3f1c12a3&scoped=true"
import script from "./AdminImportUrl.vue?vue&type=script&lang=js"
export * from "./AdminImportUrl.vue?vue&type=script&lang=js"

import "./AdminImportUrl.vue?vue&type=style&index=0&id=3f1c12a3&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3966428095/src/eelam-tv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1c12a3"]])

export default __exports__